import React, { useEffect, useMemo, useState } from 'react';
import Timer from '../../components/timer';
import GameTop from '../../components/gameTop';
import FinalBet from '../../components/finalBet';
import GameLogo from '../../components/gameLogo';
import OvalTable from '../../components/ovalTable';
import WinNumbers from '../../components/winNumbers';
import GameBottom from '../../components/gameBottom';
import SwitchTable from '../../components/switchTable';
import SnakesBetType from '../../components/snakesBetType';
import RectangleTable from '../../components/rectangleTable';
import MainGameWrapper from '../../components/mainGameWrapper';
import { GameChipsContainer } from '../../conatiners/chips-container';
import RoundLastResults from '../../components/roundLastResults';
import RightGameWrapper from '../../components/rightGameWrapper';
import MainGameContainer from '../../components/mainGameContainer';
import RightGameBottomWrapper from '../../components/rightGameBottomWrapper';
import { TableTypes } from '../../enums/tableTypes';
import {
  REC_BET_DATA_MODEL_MAP,
  OvalTableByIndex,
  CombinationTypes,
  OVAL_BET_DATA_MODEL,
} from '../../enums/tableNumbers';
import { doChipStore } from '../../store/doChipStore';
import { observer } from 'mobx-react-lite';
import { winningAmountStore } from '../../store/winningAmountStore';
import { winNumbersColor } from '../../helpers/winNumbersColor';
import { debounce, FreeBetsWrapper, isMobile } from '@pascal/pascal-core';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import Game from '../../roullette-animation/src/components/Game';

const GameMain = observer(({ isReplay }) => {
  const { gameTypeId } = gameConfigStore;
  const [selectedData, setSelectedData] = useState([]);
  const [mainTableType, setMainTableType] = useState(TableTypes.Rectangle);
  const [isShowBetActionModal, setIsShowBetActionModal] = useState(false);

  useEffect(() => {
    // rouletteGame();
  }, []);

  const { neighbors } = doChipStore;
  const { winNumber, getWinningAmount: winningAmount } = winningAmountStore;

  useEffect(() => {
    setIsShowBetActionModal(false);
  }, [gameTypeId]);

  const handleMouseMove = debounce((e, isNeighbors) => {
    const ovalTableCenterCombinations = OVAL_BET_DATA_MODEL.map((item) => item.type);
    const combinationsWithoutNeighbors = Object.keys(CombinationTypes);
    const valueType = e.target.getAttribute('data');
    if (isNeighbors && !combinationsWithoutNeighbors.includes(valueType)) {
      const OvalTableToNeighbors = [...OvalTableByIndex, ...OvalTableByIndex, ...OvalTableByIndex];
      const valueTypeIndex = OvalTableToNeighbors.findIndex(
        (item, index) => item === valueType && index > OvalTableByIndex.length
      );
      const neighborsData = OvalTableToNeighbors.slice(valueTypeIndex - neighbors, valueTypeIndex + neighbors + 1);
      const models = neighborsData.map((item) => REC_BET_DATA_MODEL_MAP[item].winNumbers[0]);
      setSelectedData([...models, 'neighbors']);
    } else {
      const model = REC_BET_DATA_MODEL_MAP[valueType];
      if (ovalTableCenterCombinations.includes(valueType)) {
        setSelectedData([...model?.winNumbers, 'OvalCombinationBets']);
      } else {
        setSelectedData(model?.winNumbers);
      }
    }
  }, 10);

  const handleMouseLeave = () => setSelectedData([]);

  const winNumbersResult = useMemo(() => {
    return winNumbersColor(winNumber);
  }, [winNumber]);

  return (
    <div className='roulette-game-wrapper'>
      <div className='roulette-anim-wr'>
        <Game />
      </div>
      <FreeBetsWrapper />
      <GameTop>
        {winNumbersResult && <WinNumbers winNumbersResult={winNumbersResult} winningAmount={winningAmount} />}
      </GameTop>
      <GameBottom
        selectedData={selectedData}
        mainTableType={mainTableType}
        handleMouseMove={handleMouseMove}
        handleMouseLeave={handleMouseLeave}
        isShowBetActionModal={isShowBetActionModal}
        setIsShowBetActionModal={setIsShowBetActionModal}
      >
        <GameLogo />
        <MainGameWrapper>
          <MainGameContainer>
            {!isReplay && <Timer />}
            {mainTableType === TableTypes.Rectangle ? (
              <RectangleTable
                selectedData={selectedData}
                handleMouseMove={handleMouseMove}
                handleMouseLeave={handleMouseLeave}
              />
            ) : (
              <OvalTable
                isReplay={isReplay}
                selectedData={selectedData}
                handleMouseMove={handleMouseMove}
                handleMouseLeave={handleMouseLeave}
              />
            )}
          </MainGameContainer>
          {!isReplay && <GameChipsContainer />}
          <SwitchTable isReplay={isReplay} mainTableType={mainTableType} setMainTableType={setMainTableType} />
        </MainGameWrapper>
        <RightGameWrapper>
          {!isReplay && (
            <RoundLastResults
              handleMouseMove={handleMouseMove}
              handleMouseLeave={handleMouseLeave}
              isShowBetActionModal={isShowBetActionModal}
              setIsShowBetActionModal={setIsShowBetActionModal}
            />
          )}
          {mainTableType === TableTypes.Rectangle ? (
            <OvalTable
              isReplay={isReplay}
              isSecondaryTable
              selectedData={selectedData}
              handleMouseMove={handleMouseMove}
              handleMouseLeave={handleMouseLeave}
            />
          ) : (
            <RectangleTable
              selectedData={selectedData}
              handleMouseMove={handleMouseMove}
              handleMouseLeave={handleMouseLeave}
            />
          )}
          <RightGameBottomWrapper>
            <FinalBet handleMouseMove={handleMouseMove} handleMouseLeave={handleMouseLeave} />
            <SnakesBetType handleMouseMove={handleMouseMove} handleMouseLeave={handleMouseLeave} />
          </RightGameBottomWrapper>
        </RightGameWrapper>
      </GameBottom>
    </div>
  );
});

export default GameMain;
